import React from 'react';
import App from './App';
import store from './app/store';
import { Provider } from 'react-redux';

export const CertificationTrainingBlock = (props) => {
  return <React.StrictMode>
    <Provider store={store}>
      <App {...props} />
    </Provider>
  </React.StrictMode>;
};
